import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type ViewMode = 'grid' | 'compact' | 'list'

interface FilterState {
  showHidden: boolean
  collapseVariants: boolean
  viewMode: ViewMode
}

interface FilterActions {
  toggleShowHidden: () => void
  toggleCollapseVariants: () => void
  setViewMode: (mode: ViewMode) => void
}

export const useFilterStore = create<FilterState & FilterActions>()(
  persist(
    (set) => ({
      showHidden: false,
      collapseVariants: true,
      viewMode: 'grid' as ViewMode,

      toggleShowHidden: () => set((state) => ({ showHidden: !state.showHidden })),
      toggleCollapseVariants: () => set((state) => ({ collapseVariants: !state.collapseVariants })),
      setViewMode: (mode: ViewMode) => set({ viewMode: mode }),
    }),
    {
      name: 'treasurelog-filters',
      version: 7,
      migrate: (persistedState: unknown, version: number) => {
        const state = persistedState as FilterState & { listsTab?: string; collectionTab?: string }
        if (version < 5) {
          const { listsTab: _, collectionTab: _2, ...rest } = state
          return {
            ...rest,
            showHidden: state.showHidden ?? false,
            collapseVariants: state.collapseVariants ?? false,
            viewMode: 'grid' as ViewMode,
          }
        }
        if (version < 6) {
          return {
            ...state,
            viewMode: 'grid' as ViewMode,
          }
        }
        if (version < 7) {
          return {
            ...state,
            collapseVariants: true,
          }
        }
        return state as FilterState & FilterActions
      },
      merge: (persistedState, currentState) => ({
        ...currentState,
        ...(persistedState as FilterState),
      }),
    },
  ),
)
